module.exports = __webpack_public_path__ + "media/Glowkit-UpdateKeys.510f1342.mp4";